export default __webpack_public_path__ + "static/media/logo.a4fa44ef.png";